import type { TextFieldProps } from '@mui/material';
import { TextField } from '@mui/material';
import type { ChangeEvent } from 'react';

import { useFieldContext } from '@/hooks/useFieldContext';

type NumberFieldProps = Omit<TextFieldProps, 'type'>;

export function NumberField(props: NumberFieldProps) {
  const field = useFieldContext<number | null>();

  let error: string | undefined;
  if (typeof field.state.meta.errors[0] === 'string') {
    [error] = field.state.meta.errors;
  } else if (field.state.meta.errors[0] && 'message' in field.state.meta.errors[0]) {
    error = field.state.meta.errors[0].message;
  }

  return (
    <TextField
      fullWidth
      error={!!field.state.meta.errors.length}
      helperText={error}
      name={field.name}
      onBlur={field.handleBlur}
      type="number"
      value={field.state.value ?? ''}
      onChange={(event: ChangeEvent<HTMLInputElement>) => {
        field.handleChange(Number.isNaN(event.target.valueAsNumber) ? null : event.target.valueAsNumber);
      }}
      {...props}
    />
  );
}
